import { useState, useMemo, useEffect, useRef } from "preact/hooks";
import { schemeBlues } from "d3-scale-chromatic";
import { DonationModal } from "../DonationModal";
import { Table } from "../Table/Table";
import { DownloadPlotButtons } from "./DownloadPlotButtons";
import { ColorSchemePicker } from "./ColorSchemePicker";
import { WindRose } from "./WindRose";
import { initDb } from "../../helpers/initDb";
import { sumRow } from "../../helpers/initData";

const getHourUTC = () => {
  const thisHour = new Date();
  thisHour.setMinutes(0);
  thisHour.setSeconds(0);
  const hourUTCString = thisHour.toUTCString();

  return hourUTCString;
};

function MakeWindrose({
  onDownloadSvg,
  onDownloadPng,
  onClickedNo,
  showDonateModal,
  tableColumns,
  initialTableData,
  binsTitle,
  bins,
  binUnits,
  yUnits,
}) {
  // console.group("<MakeWindRose />");
  // console.log({ bins });
  // console.log({ tableColumns });
  // console.log({ initialTableData });
  // console.groupEnd();

  const idb = useRef();
  const [colorScheme, setColorScheme] = useState(() => ({
    colors: schemeBlues[bins.length],
    title: "Blues",
  }));

  const columns = useMemo(() => tableColumns, []);

  const [tableData, setTableData] = useState(() => initialTableData);
  const [originalData] = useState(tableData);

  useEffect(() => {
    idb.current = initDb();
  }, []);

  useEffect(() => {
    const hourUTC = getHourUTC();
    idb.current.then((db) => db.put("bins", bins, hourUTC));
  }, [bins]); // so fires only on init as bins don't change

  useEffect(() => {
    const hourUTC = getHourUTC();
    idb.current.then((db) => db.put("tableData", tableData, hourUTC));
  }, [tableData]);

  // not sure wether to do this here or on the <DefineMetadata /> comp
  useEffect(() => {
    const hourUTC = getHourUTC();
    idb.current.then((db) =>
      db.put("metadata", { binsTitle, binUnits, yUnits }, hourUTC)
    );
  }, [binsTitle, binUnits, yUnits]); // also fires only on init

  // When our cell renderer calls updateMyData, we'll use the rowIndex, columnId and
  // new value to update the original data
  const updateMyData = (rowIndex, columnId, value) => {
    setTableData((oldTableData) =>
      oldTableData.map((row, index) => {
        if (index === rowIndex) {
          // update row total
          delete row.total;

          const updatedRow = {
            ...oldTableData[rowIndex],
            [columnId]: value,
          };

          updatedRow.total = sumRow(updatedRow);

          return updatedRow;
        }

        return row;
      })
    );
  };

  const resetData = () => setTableData(originalData);

  return (
    <div>
      <ColorSchemePicker
        binsLength={bins.length}
        selectedColorSchemeTitle={colorScheme.title}
        setColorScheme={setColorScheme}
      />
      <section class="flex flex-wrap justify-evenly">
        <Table
          colorSchemeColors={colorScheme.colors}
          columns={columns}
          data={tableData}
          updateMyData={updateMyData}
          resetData={resetData}
        />
        <div>
          <WindRose
            data={tableData}
            bins={bins}
            binsTitle={binsTitle}
            binUnits={binUnits}
            yUnits={yUnits}
            colorSchemeColors={colorScheme.colors}
          />
          <DownloadPlotButtons
            onDownloadSvg={onDownloadSvg}
            onDownloadPng={onDownloadPng}
          />
          {showDonateModal ? <DonationModal onClickedNo={onClickedNo} /> : null}
        </div>
      </section>
    </div>
  );
}

export { MakeWindrose };
